import script from "./PropertyListingFigma.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyListingFigma.vue?vue&type=script&setup=true&lang=js"

import "./PropertyListingFigma.vue?vue&type=style&index=0&id=5780a0cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5780a0cc"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QPagination});
